/**
 * Zestina Collection — AJAX filter/sort/paginate with section_id rendering.
 *
 *  - Sort buttons update sort_by, submit form → refresh section
 *  - Filter checkboxes submit form on change → refresh section
 *  - "Akcije" / "Novo" toggles map to filter.p.tag param
 *  - Pagination + filter pill remove links intercepted → AJAX swap
 *  - History API keeps URL in sync
 *  - Quantity +/- buttons on product cards (scoped to this section)
 */
(function () {
  if (window.__zCollInit) return;
  window.__zCollInit = true;

  const ROOT_SELECTOR = '[data-z-coll]';

  function root() { return document.querySelector(ROOT_SELECTOR); }

  function getSectionId() {
    const r = root();
    return r ? r.getAttribute('data-section-id') : null;
  }

  function setLoading(on) {
    const r = root();
    if (r) r.setAttribute('data-loading', on ? 'true' : 'false');
  }

  const TOGGLE_SUBTITLES = {
    'Akcija': { on: 'Samo na akciji', off: 'Svi proizvodi' },
    'Novo':   { on: 'Samo novi proizvodi', off: 'Svi proizvodi' },
  };

  const SORT_LABELS = {
    'title-ascending':  'Naziv A-Z',
    'title-descending': 'Naziv Z-A',
    'price-ascending':  'Cena: Rastuće',
    'price-descending': 'Cena: Opadajuće',
  };

  function updateToggleSubtitle(toggle, isOn) {
    const tag = toggle.getAttribute('data-z-tag-toggle');
    const copy = TOGGLE_SUBTITLES[tag];
    if (!copy) return;
    const sub = toggle.closest('.z-coll__toggle')?.querySelector('.z-coll__toggle-sub');
    if (sub) sub.textContent = isOn ? copy.on : copy.off;
  }

  // Sync tag-toggle state + subtitles with the current URL. Liquid renders a best-effort
  // initial state but can miss cases where no products match the tag — this is the source of truth.
  function syncTagTogglesFromURL() {
    const params = new URLSearchParams(window.location.search);
    const activeTags = params.getAll('filter.p.tag');
    document.querySelectorAll('[data-z-tag-toggle]').forEach((toggle) => {
      const tag = toggle.getAttribute('data-z-tag-toggle');
      const isOn = activeTags.includes(tag);
      toggle.setAttribute('aria-pressed', String(isOn));
      updateToggleSubtitle(toggle, isOn);
    });
    syncActiveBarFromURL(activeTags);
    syncSortFromURL();
  }

  // Highlight the sort button matching the URL's sort_by param (or Podrazumevano if absent).
  // Liquid can't distinguish "user picked default" from "no URL param", so state is JS-driven.
  function syncSortFromURL() {
    const params = new URLSearchParams(window.location.search);
    const urlSort = params.get('sort_by') || '';
    document.querySelectorAll('[data-z-sort]').forEach((btn) => {
      const val = btn.getAttribute('data-z-sort');
      const isActive = urlSort ? val === urlSort : val === 'manual';
      btn.setAttribute('aria-pressed', String(isActive));
    });
    const sortInput = document.querySelector('[data-z-sort-input]');
    if (sortInput) sortInput.value = urlSort;
    // Reflect the active option in the compact sort-dropdown summary label
    const activeBtn = document.querySelector('[data-z-sortbar] [data-z-sort][aria-pressed="true"]');
    const activeVal = activeBtn ? activeBtn.getAttribute('data-z-sort') : '';
    const label = activeBtn && activeVal !== 'manual'
      ? (activeBtn.getAttribute('data-z-sort-label') || 'Sortiraj')
      : 'Sortiraj';
    document.querySelectorAll('[data-z-sortbar-label]').forEach((el) => { el.textContent = label; });
  }

  // Ensure active filter bar shows a pill for every URL-active shortcut tag (Akcija, Novo),
  // plus a Sortiranje pill when sort_by is set.
  function syncActiveBarFromURL(activeTags) {
    const bar = document.querySelector('[data-z-active-bar]');
    if (!bar) return;
    const clearBtn = bar.querySelector('[data-z-reset]');
    const shortcuts = ['Akcija', 'Novo'];

    shortcuts.forEach((tag) => {
      const existing = bar.querySelector(`[data-z-pill-tag="${tag}"]`);
      const shouldShow = activeTags.includes(tag);
      if (shouldShow && !existing) {
        const params = new URLSearchParams(window.location.search);
        const remaining = params.getAll('filter.p.tag').filter((t) => t !== tag);
        params.delete('filter.p.tag');
        remaining.forEach((t) => params.append('filter.p.tag', t));
        const removeUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');

        const pill = document.createElement('span');
        pill.className = 'z-coll__active-pill';
        pill.setAttribute('data-z-pill-tag', tag);
        pill.innerHTML = `
          <strong>Tag:</strong>
          <span class="z-coll__active-pill-value">${tag}</span>
          <a href="${removeUrl}" class="z-coll__active-pill-remove" aria-label="Ukloni filter" data-z-pill-remove>
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </a>
        `;
        bar.insertBefore(pill, clearBtn);
      } else if (!shouldShow && existing) {
        existing.remove();
      }
    });

    // Sort pill
    const urlSort = new URLSearchParams(window.location.search).get('sort_by') || '';
    const existingSortPill = bar.querySelector('[data-z-pill-sort]');
    if (urlSort && SORT_LABELS[urlSort]) {
      if (!existingSortPill) {
        const params = new URLSearchParams(window.location.search);
        params.delete('sort_by');
        const removeUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');

        const pill = document.createElement('span');
        pill.className = 'z-coll__active-pill';
        pill.setAttribute('data-z-pill-sort', urlSort);
        pill.innerHTML = `
          <strong>Sortiranje:</strong>
          <span class="z-coll__active-pill-value">${SORT_LABELS[urlSort]}</span>
          <a href="${removeUrl}" class="z-coll__active-pill-remove" aria-label="Ukloni sortiranje" data-z-pill-remove>
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </a>
        `;
        bar.insertBefore(pill, clearBtn);
      }
    } else if (existingSortPill) {
      existingSortPill.remove();
    }

    const hasPills = bar.querySelector('.z-coll__active-pill');
    if (hasPills) bar.removeAttribute('hidden');
    else bar.setAttribute('hidden', '');
  }

  function scrollToTop() {
    const r = root();
    if (!r) return;
    const top = r.getBoundingClientRect().top + window.scrollY - 20;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  // Build URL params from the current filter form (excluding empty values)
  function formToParams(form) {
    const params = new URLSearchParams();
    if (!form) return params;
    const fd = new FormData(form);
    for (const [key, value] of fd.entries()) {
      if (value !== '' && value != null) params.append(key, value);
    }
    return params;
  }

  // Fetch + swap section for any URL (same path with changed params, OR different /collections/* path).
  async function applyUrl(target, { pushState = true } = {}) {
    const sectionId = getSectionId();
    if (!sectionId) return;

    let pathname, qs;
    if (target instanceof URLSearchParams) {
      pathname = window.location.pathname;
      qs = target.toString();
    } else {
      const u = new URL(target, window.location.origin);
      pathname = u.pathname;
      qs = u.searchParams.toString();
    }
    const newUrl = qs ? `${pathname}?${qs}` : pathname;

    setLoading(true);
    try {
      const fetchUrl = `${pathname}?${qs ? qs + '&' : ''}section_id=${sectionId}`;
      const res = await fetch(fetchUrl, {
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' },
      });
      if (!res.ok) throw new Error('fetch failed');
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(ROOT_SELECTOR);
      const current = root();
      if (!fresh || !current) throw new Error('root missing');

      current.innerHTML = fresh.innerHTML;

      if (pushState) history.pushState({ zColl: true }, '', newUrl);

      // Update browser tab title from the new H1 if collection changed
      const h1 = current.querySelector('.z-coll__title');
      if (h1 && h1.textContent.trim()) {
        const suffix = document.title.includes(' – ') ? document.title.split(' – ').pop() : '';
        document.title = suffix ? `${h1.textContent.trim()} – ${suffix}` : h1.textContent.trim();
      }

      syncTagTogglesFromURL();
    } catch (e) {
      window.location.assign(newUrl);
    } finally {
      setLoading(false);
    }
  }

  // Back-compat alias
  const applyParams = applyUrl;

  // Build params from current URL minus keys the form owns — preserves price-range or
  // other filters not rendered in our custom UI
  function currentParamsWithoutForm(form) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    if (!form) return params;
    const formNames = new Set();
    form.querySelectorAll('input, select').forEach((el) => {
      if (el.name) formNames.add(el.name);
    });
    for (const key of Array.from(params.keys())) {
      if (formNames.has(key) || key === 'sort_by' || key === 'page') {
        params.delete(key);
      }
    }
    return params;
  }

  function submitForm() {
    const form = document.querySelector('[data-z-filter-form]');
    if (!form) return;
    const preserved = currentParamsWithoutForm(form);
    const formParams = formToParams(form);
    // Merge: form params override preserved
    for (const [k, v] of formParams.entries()) {
      preserved.append(k, v);
    }
    // Reset pagination on any filter/sort change
    preserved.delete('page');
    applyParams(preserved);
  }

  // --- Event wiring (delegated; survives section swaps) ---

  // Close the compact sort dropdown when clicking outside of it
  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-z-sortbar][open]').forEach((d) => {
      if (!d.contains(e.target)) d.open = false;
    });
  });

  // Sort buttons
  document.addEventListener('click', (e) => {
    const sortBtn = e.target.closest('[data-z-sort]');
    if (sortBtn) {
      e.preventDefault();
      const val = sortBtn.getAttribute('data-z-sort');
      const form = document.querySelector('[data-z-filter-form]');
      const input = form?.querySelector('[data-z-sort-input]');
      if (input) {
        input.value = val === 'manual' ? '' : val;
      }
      // Update pressed state optimistically
      document.querySelectorAll('[data-z-sort]').forEach((b) => {
        b.setAttribute('aria-pressed', b === sortBtn ? 'true' : 'false');
      });
      // Close the compact sort dropdown if the click came from it
      document.querySelectorAll('[data-z-sortbar][open]').forEach((d) => { d.open = false; });
      submitForm();
      return;
    }

    // Category pill (menu-based link, single-select)
    const catLinkBtn = e.target.closest('[data-z-cat-link]');
    if (catLinkBtn && !catLinkBtn.disabled) {
      e.preventDefault();
      const url = catLinkBtn.getAttribute('data-z-cat-link');
      const wasActive = catLinkBtn.getAttribute('aria-pressed') === 'true';
      const targetPath = wasActive ? '/collections/all' : url;

      // Preserve sort + shortcut tags across collection switch
      const curr = new URLSearchParams(window.location.search);
      const preserved = new URLSearchParams();
      const sortBy = curr.get('sort_by');
      if (sortBy) preserved.set('sort_by', sortBy);
      curr.getAll('filter.p.tag').forEach((t) => preserved.append('filter.p.tag', t));

      const finalUrl = preserved.toString()
        ? `${targetPath}?${preserved.toString()}`
        : targetPath;

      // Optimistic: toggle pressed state immediately
      document.querySelectorAll('[data-z-cat-link]').forEach((b) => {
        b.setAttribute('aria-pressed', b === catLinkBtn && !wasActive ? 'true' : 'false');
      });
      applyUrl(finalUrl);
      return;
    }

    // Intercept any /collections/* link (e.g. header dropdown) → AJAX swap
    const collectionLink = e.target.closest('a[href^="/collections/"]');
    if (collectionLink && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey && root()) {
      const href = collectionLink.getAttribute('href');
      // Skip if the link is inside the section's product grid / card (those are /products/* anyway, but guard)
      // and skip any link that opts out
      if (!collectionLink.hasAttribute('data-no-ajax')) {
        e.preventDefault();
        applyUrl(href);
        // Also close any header dropdown on same click
        document.querySelectorAll('[data-z-dropdown]').forEach((d) => d.removeAttribute('data-z-open'));
        return;
      }
    }

    // Tag-shortcut toggles (Akcije / Novo) — manipulate URL directly so state is
    // always accurate regardless of whether Shopify returned matching products.
    const tagToggle = e.target.closest('[data-z-tag-toggle]');
    if (tagToggle) {
      e.preventDefault();
      const tag = tagToggle.getAttribute('data-z-tag-toggle');
      const isOn = tagToggle.getAttribute('aria-pressed') === 'true';

      const params = new URLSearchParams(window.location.search);
      const existingTags = params.getAll('filter.p.tag');
      params.delete('filter.p.tag');

      const nextTags = isOn
        ? existingTags.filter((t) => t !== tag)
        : [...existingTags.filter((t) => t !== tag), tag];
      nextTags.forEach((t) => params.append('filter.p.tag', t));
      params.delete('page');

      // Optimistic UI so the user sees feedback before fetch returns
      tagToggle.setAttribute('aria-pressed', String(!isOn));
      updateToggleSubtitle(tagToggle, !isOn);

      applyParams(params);
      return;
    }

    // Pagination links
    const pageLink = e.target.closest('[data-z-page]');
    if (pageLink && pageLink.tagName === 'A') {
      e.preventDefault();
      const href = pageLink.getAttribute('href');
      const u = new URL(href, window.location.origin);
      applyParams(new URLSearchParams(u.search));
      scrollToTop();
      return;
    }

    // Pill remove
    const pillRemove = e.target.closest('[data-z-pill-remove]');
    if (pillRemove && pillRemove.tagName === 'A') {
      e.preventDefault();
      const href = pillRemove.getAttribute('href');
      const u = new URL(href, window.location.origin);
      applyParams(new URLSearchParams(u.search));
      return;
    }

    // Reset buttons
    const resetLink = e.target.closest('[data-z-reset]');
    if (resetLink && resetLink.tagName === 'A') {
      e.preventDefault();
      const href = resetLink.getAttribute('href');
      const u = new URL(href, window.location.origin);
      applyParams(new URLSearchParams(u.search));
      return;
    }

    // Mobile sidebar open/close
    const sidebarOpen = e.target.closest('[data-z-sidebar-open]');
    if (sidebarOpen) {
      const sb = document.querySelector('[data-z-sidebar]');
      const bd = document.querySelector('[data-z-sidebar-backdrop]');
      const nowOpen = sb?.getAttribute('data-open') !== 'true';
      if (sb) sb.setAttribute('data-open', nowOpen ? 'true' : 'false');
      if (bd) bd.setAttribute('data-open', nowOpen ? 'true' : 'false');
      if (nowOpen) document.documentElement.dataset.zSidebarOpen = 'true';
      else document.documentElement.removeAttribute('data-z-sidebar-open');
      return;
    }
    const sidebarClose = e.target.closest('[data-z-sidebar-close]');
    if (sidebarClose) {
      const sb = document.querySelector('[data-z-sidebar]');
      const bd = document.querySelector('[data-z-sidebar-backdrop]');
      if (sb) sb.setAttribute('data-open', 'false');
      if (bd) bd.setAttribute('data-open', 'false');
      document.documentElement.removeAttribute('data-z-sidebar-open');
      return;
    }

  });

  // Filter checkboxes → submit form on change
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-z-filter-input]');
    if (!input) return;
    submitForm();
  });

  // Back/forward support
  window.addEventListener('popstate', () => {
    const r = root();
    if (!r) return;
    const params = new URLSearchParams(window.location.search);
    applyParams(params, { pushState: false });
  });

  // Initial sync on first load — covers the edge case where Shopify didn't include
  // a tag in active_values (e.g. no matching products) but the URL still has it.
  if (document.readyState !== 'loading') syncTagTogglesFromURL();
  else document.addEventListener('DOMContentLoaded', syncTagTogglesFromURL);
})();
